import produce from 'immer';
import { Reducer } from 'redux';
import {
  ProductsFetchApiFailureAction,
  ProductsFetchApiRequestAction,
  ProductsFetchApiSuccessAction,
} from '../actions/fetch.actions';
import { PRODUCTS_FETCH_API_SUCCESS } from '../constants';
import { ProductsSearchState } from '../types';

export const initialSearchState: ProductsSearchState = {
  allIds: [],
  allProductIds: [],
};

export type ProductsSearchAction =
  | ProductsFetchApiFailureAction
  | ProductsFetchApiRequestAction
  | ProductsFetchApiSuccessAction;

export const productsSearchReducer: Reducer<ProductsSearchState, ProductsSearchAction> = (
  state: ProductsSearchState = initialSearchState,
  action: ProductsSearchAction
): ProductsSearchState =>
  produce(state, (draft) => {
    switch (action.type) {
      case PRODUCTS_FETCH_API_SUCCESS: {
        const { ids, allProductIds } = action.payload.response.result;
        draft.allIds = ids;
        draft.allProductIds = allProductIds;
        break;
      }

      default:
        return draft;
    }
    return draft;
  });
